import { LoggerProvider, BatchLogRecordProcessor } from '@opentelemetry/sdk-logs';
import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import { SeverityNumber } from '@opentelemetry/api-logs';
import { resourceFromAttributes } from '@opentelemetry/resources';
import posthog from './posthog';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com';

let logger = null;

const SEVERITY_MAP = {
  trace: SeverityNumber.TRACE,
  debug: SeverityNumber.DEBUG,
  info: SeverityNumber.INFO,
  warn: SeverityNumber.WARN,
  error: SeverityNumber.ERROR,
  fatal: SeverityNumber.FATAL,
};

// Redact sensitive patterns from strings
function sanitize(str) {
  if (typeof str !== 'string') return str;
  return str
    .replace(/eyJ[A-Za-z0-9_-]+\.eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+/g, '[REDACTED_JWT]')
    .replace(/(Bearer\s+)\S+/gi, '$1[REDACTED]')
    .replace(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g, '[REDACTED_EMAIL]')
    .replace(/\b(phc_|phx_|sk_|pk_)[A-Za-z0-9_-]+/g, '[REDACTED_KEY]');
}

export function initPostHogLogs() {
  if (!POSTHOG_KEY) {
    console.warn('PostHog Logs disabled: REACT_APP_POSTHOG_KEY not set');
    return;
  }

  const exporter = new OTLPLogExporter({
    url: `${POSTHOG_HOST}/i/v1/logs`,
    headers: {
      Authorization: `Bearer ${POSTHOG_KEY}`,
    },
  });

  const loggerProvider = new LoggerProvider({
    resource: resourceFromAttributes({
      'service.name': 'fastestform-frontend',
    }),
    processors: [new BatchLogRecordProcessor(exporter)],
  });

  console.log("PG here cm")

  logger = loggerProvider.getLogger('fastestform-frontend');
}

export function emitLog({ severityText, body, attributes = {} }) {
  console.log("EmigLog 1")
  if (!logger) return;

  console.log("EmigLog 2")

  const sanitizedBody = sanitize(String(body));
  const sanitizedAttributes = {};
  console.log("EmigLog 3")
  for (const [key, value] of Object.entries(attributes)) {
    sanitizedAttributes[key] = typeof value === 'string' ? sanitize(value) : value;
  }
  console.log("EmigLog 4")

  // Attach PostHog IDs for correlation
  if (posthog.__loaded) {
    const distinctId = posthog.get_distinct_id();
    const sessionId = posthog.get_session_id();
    if (distinctId) sanitizedAttributes['posthog.distinct_id'] = distinctId;
    if (sessionId) sanitizedAttributes['posthog.session_id'] = sessionId;
  }

  console.log("EmigLog 5")

  logger.emit({
    severityText,
    severityNumber: SEVERITY_MAP[severityText.toLowerCase()] || SeverityNumber.INFO,
    body: sanitizedBody,
    attributes: sanitizedAttributes,
  });
}
